import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { MedicalInformationView } from "./view";
import { useNavigate } from "react-router-dom";
import "./style.css";
import showToast from "../../services/toast";
import LocalStorageService from "../../services/localStorage";
import { Steps } from "../../enum/steps";
import { navigateBack, navigateNext, stepProgress, } from "../../dataBase/stepProgress";
import { hasPermission } from "../../services/getNavigationPages";
import { STEP_MEDICALINFORMATION } from "../../const/catalog";
import { useTranslation } from "react-i18next";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var MedicalInformationPage = function () {
    var STEP = STEP_MEDICALINFORMATION;
    var navigate = useNavigate();
    var _a = React.useState("0.00"), prima = _a[0], setPrima = _a[1];
    var t = useTranslation().t;
    var _b = useState(false), showInfo = _b[0], setShowInfo = _b[1];
    var _c = React.useState([]), steps = _c[0], setSteps = _c[1];
    var _d = useState([]), filters = _d[0], setFilters = _d[1];
    var _e = React.useState([]), breadCrumbs = _e[0], setBreadCrumbs = _e[1];
    var _f = useState(true), showNextDisabled = _f[0], setShowNextDisabled = _f[1];
    var _g = useState(false), loading = _g[0], setLoading = _g[1];
    var _h = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _h[0], setSeeToast = _h[1];
    var permissions = {
        create: hasPermission("applican-declaration-view"),
    };
    var storageKey = "afy-steps";
    var localStorageService = new LocalStorageService(storageKey);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        setBreadCrumbs(stepProgress(STEP, true));
        setSteps(stepProgress(STEP));
        setFilters([
            {
                name: t("financialInformation.dataFilter.Product"),
                label: (_a = localStorageService.getStepStored().steps[Steps.insurance]) === null || _a === void 0 ? void 0 : _a.name,
                type: "label",
            },
            /* {
              name: tl("financialInformation.dataFilter.TypeOfPlan"),
              label: "Vida",
              type: "label",
            },*/
            {
                name: t("financialInformation.dataFilter.Birthdate"),
                label: new Date((_c = (_b = localStorageService.getStepStored().steps[Steps.initialInfo]) === null || _b === void 0 ? void 0 : _b.initialInfo) === null || _c === void 0 ? void 0 : _c.dateBirth).toLocaleDateString("es-GT"),
                type: "label",
            },
            {
                name: t("financialInformation.dataFilter.Gender"),
                label: (_e = (_d = localStorageService.getStepStored().steps[Steps.initialInfo]
                    .initialInfo) === null || _d === void 0 ? void 0 : _d.sexType) === null || _e === void 0 ? void 0 : _e.name,
                type: "label",
            },
            {
                name: t("financialInformation.dataFilter.PolicyDuration"),
                label: ((_f = localStorageService.getStepStored().steps[Steps.initialInfo]
                    .initialInfo) === null || _f === void 0 ? void 0 : _f.policyDuration) + " años",
                type: "label",
            },
            {
                name: t("financialInformation.dataFilter.SumInsured"),
                label: "RD$ ".concat((_h = (_g = localStorageService.getStepStored().steps[Steps.initialInfo]) === null || _g === void 0 ? void 0 : _g.initialInfo) === null || _h === void 0 ? void 0 : _h.premium),
                type: "label",
            },
        ]);
    }, []);
    var handleClickPrevious = function (e) {
        navigateBack(STEP, navigate);
    };
    var handleClickNext = function (e) {
        if (e && e.constructor.name === "SyntheticBaseEvent") {
            navigateNext(STEP, navigate);
            return;
        }
        setLoading(true);
        try {
            setShowNextDisabled(false);
            // localStorageService.setStepStored({
            //   id: "",
            //   name: "",
            //   step: Steps.medicalInformation,
            //   completed: true,
            //   medicalInfo: e,
            // });
            setSeeToast({
                show: true,
                message: "Los datos han sido guardados",
                type: typeAlert.success,
            });
            setLoading(false);
        }
        catch (error) {
            console.log(error);
            setLoading(false);
            setShowNextDisabled(true);
            setSeeToast({
                show: true,
                message: "Error al guardar",
                type: typeAlert.error,
            });
        }
    };
    return (_jsxs(React.Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loading, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: "Cargando" }), _jsx(MedicalInformationView, { title: "Información médica", steps: steps, hideFilter: false, breadcrumbs: breadCrumbs, stepProgress: steps, previousLabel: "Anterior", nextLabel: "Nueva cotización", nextDisabled: showNextDisabled, showInfo: showInfo, onClickNext: handleClickNext, onClickPrevious: handleClickPrevious, filters: filters, resumeDescription: "Valor estimado", resumeValue: "DOP $ ".concat(prima) })] }));
};
